import { TabStyles } from '../../styles/TabStyles';
import { HorizontalOriginOption, OverlayProps, VerticalOriginOption } from '../../utils/Overlay';

export const DefaultMaxWidth: number = 300;

/** This is padding between the anchor client rect boundary and the tooltip overlay boundary. */
export const AnchorClientRectPadding: number = 6;

export const BorderWidth: number = TabStyles.Sizing.BorderWidth;
export const Padding: number = 12;

export const AggregateTooltipPadding: number = 2 * (BorderWidth + Padding);

export const ContentWrapperStyle: React.CSSProperties = {
  backgroundColor: TabStyles.Colors.White,
  borderColor: TabStyles.Colors.L5,
  borderRadius: TabStyles.Sizing.BorderRadius,
  borderStyle: 'solid',
  borderWidth: BorderWidth,
  boxShadow: TabStyles.Shadow.Elevated,
  boxSizing: 'border-box',
  display: 'block',
  fontSize: TabStyles.Typography.Sizing.Default,
  lineHeight: 'normal',
  padding: Padding,
};

export enum TooltipPosition {
  TopLeftCorner = 'TopLeftCorner',
  Top = 'Top',
  TopRightCorner = 'TopRightCorner',
  Right = 'Right',
  BottomRightCorner = 'BottomRightCorner',
  Bottom = 'Bottom',
  BottomLeftCorner = 'BottomLeftCorner',
  Left = 'Left',
}

export interface TooltipPositionInfo extends Pick<OverlayProps, 'anchorOrigin' | 'stackedOrigin'> { }

export const TooltipPositionInfoMap: { [key in TooltipPosition]: TooltipPositionInfo } = {
  [TooltipPosition.TopLeftCorner]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.top },
    stackedOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.bottom },
  },
  [TooltipPosition.Top]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.centerX, vertical: VerticalOriginOption.top },
    stackedOrigin: { horizontal: HorizontalOriginOption.centerX, vertical: VerticalOriginOption.bottom },
  },
  [TooltipPosition.TopRightCorner]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.top },
    stackedOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.bottom },
  },
  [TooltipPosition.Right]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.centerY },
    stackedOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.centerY },
  },
  [TooltipPosition.BottomRightCorner]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.bottom },
    stackedOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.top },
  },
  [TooltipPosition.Bottom]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.centerX, vertical: VerticalOriginOption.bottom },
    stackedOrigin: { horizontal: HorizontalOriginOption.centerX, vertical: VerticalOriginOption.top },
  },
  [TooltipPosition.BottomLeftCorner]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.bottom },
    stackedOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.top },
  },
  [TooltipPosition.Left]: {
    anchorOrigin: { horizontal: HorizontalOriginOption.left, vertical: VerticalOriginOption.centerY },
    stackedOrigin: { horizontal: HorizontalOriginOption.right, vertical: VerticalOriginOption.centerY },
  },
};

export function adjustClientRectForOffset(clientRect: ClientRect): ClientRect {
  return {
    bottom: clientRect.bottom + AnchorClientRectPadding,
    // 2 * AnchorClientRectPadding accounts for the left and right offsets of AnchorClientRectPadding
    height: clientRect.height + (2 * AnchorClientRectPadding),
    left: clientRect.left - AnchorClientRectPadding,
    right: clientRect.right + AnchorClientRectPadding,
    top: clientRect.top - AnchorClientRectPadding,
    // 2 * AnchorClientRectPadding accounts for the top and bottom offsets of AnchorClientRectPadding
    width: clientRect.width + (2 * AnchorClientRectPadding),
  };
}
